module.exports = __webpack_public_path__ + "img/img5.17830698.jpg";